// import React, { useState, useEffect } from 'react';
// import { BASE_URL } from '../../../constant/api';
// import { Link } from 'react-router-dom';

// function ImageCarousel({ products = [], title, view_all_url }) {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Auto-play functionality
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % products.length);
//     }, 3000); // Change slide every 3 seconds
//     return () => clearInterval(interval); // Cleanup on unmount
//   }, [products.length]);

//   return (
//     <div className="carousel-container">
//       <div className='flex justify-between items-center px-5'>
//         <h2 className="text-2xl md:text-3xl font-semibold mb-4 ">{title}</h2>
//         <p className='text-xl text-brand-text-light hover:text-brand-primary transition duration-500 ease-in-out'>

//           <Link to={view_all_url}>
//             view all
//           </Link>
//         </p>
//       </div>
//       <div>
//         {products.length > 0 ? (
//           // <Link to={`/sponsored/${products[currentIndex]?.id}/`}>
//           //   <div className="h-[130px] md:h-[258px] rounded-sm mx-5">
//           //     <img
//           //       src={
//           //         products[currentIndex].banner
//           //           ? products[currentIndex].banner.startsWith(BASE_URL)
//           //             ? products[currentIndex].banner
//           //             : `${BASE_URL}${products[currentIndex].banner}`
//           //           : '/images/default-product.png'
//           //       }
//           //       alt={products[currentIndex].name || 'Product'}
//           //       className="w-full h-full object-fill rounded-lg"
//           //       onError={(e) => {
//           //         e.target.src = '/images/default-product.png';
//           //       }}
//           //     />
//           //   </div>
//           // </Link>
//           <Link to={`${products[currentIndex]?.path}`}>
//             <div className="h-[100px] md:h-auto rounded-sm mx-5">
//               <img
//                 src={ products[currentIndex].banner }
//                 alt={products[currentIndex].name || 'Product'}
//                 className="w-full h-full object-fill rounded-lg"
//                 onError={(e) => {
//                   e.target.src = '/images/default-product.png';
//                 }}
//               />
//             </div>
//           </Link>
//         ) : (
//           <div className="text-center text-gray-500 ">
//             No products available
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default ImageCarousel;

import React, { useState, useEffect, useRef } from 'react';
import { BASE_URL } from '../../../constant/api';
import { Link } from 'react-router-dom';

function ImageCarousel({ products = [], title, view_all_url }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showViewAll, setShowViewAll] = useState(false);
  const containerRef = useRef(null);

  // Check if we need to show "View All" button
  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && products.length > 1) {
        setShowViewAll(true);
      } else {
        setShowViewAll(false);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [products.length]);

  // Auto-play functionality
  useEffect(() => {
    if (products.length > 1) { // Only auto-play if there are multiple products
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % products.length);
      }, 3000); // Change slide every 3 seconds
      return () => clearInterval(interval); // Cleanup on unmount
    }
  }, [products.length]);

  return (
    <div className="carousel-container" ref={containerRef}>
      <div className='flex justify-between items-center px-5'>
        <h2 className="text-2xl md:text-3xl font-semibold mb-4">{title}</h2>
        {showViewAll && (
          <p className='text-xl text-brand-text-light hover:text-brand-primary transition duration-500 ease-in-out'>
            <Link to={view_all_url}>
              View All
            </Link>
          </p>
        )}
      </div>
      <div>
        {products.length > 0 ? (
          <Link to={`${products[currentIndex]?.path}`}>
            <div className="h-[100px] md:h-auto rounded-sm mx-5">
              <img
                src={products[currentIndex].banner}
                alt={products[currentIndex].name || 'Product'}
                className="w-full h-full object-fill rounded-lg"
                onError={(e) => {
                  e.target.src = '/images/default-product.png';
                }}
              />
            </div>
          </Link>
        ) : (
          <div className="text-center text-gray-500">
            No products available
          </div>
        )}
      </div>
    </div>
  );
}

export default ImageCarousel;
